module.exports = __webpack_public_path__ + "img/arrows-angle-contract.988c762f.svg";